import { render } from "./TableUserValue.vue?vue&type=template&id=6b8ac3f9"
import script from "./TableUserValue.vue?vue&type=script&lang=js"
export * from "./TableUserValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__